import { Root } from '@makemydeal/dr-activities-open-deal-v2';
import { OPEN_DEAL_ROOT_ROUTE } from '../constants';
import { getOpenDealSelectors } from '../config';

export const OpenDealContainer = () => {
    const selectors = getOpenDealSelectors();
    return <Root baseRoute={OPEN_DEAL_ROOT_ROUTE} selectors={selectors} />;
};
